import { useMemo } from "react";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import { inventoryPresentation } from "../pages/inventoryIntelligenceMessages";

export default function InventoryQuantity({ value, formatted, unavailableTitle, unitName, optional = false, signed = false, unitOptions = [], selectedLevel, onUnitChange, itemName, alignDecimals = false, maximumFractionDigits = 2 }) {
  const { languageId } = usePmsTheme();
  const { t, formatDecimal, formatOptionalDecimal, formatSignedDecimal } = useMemo(() => inventoryPresentation(languageId, maximumFractionDigits), [languageId, maximumFractionDigits]);
  const formattedValue = formatted ?? (signed
    ? formatSignedDecimal(value)
    : optional
    ? formatOptionalDecimal(value)
    : formatDecimal(value));
  const resolvedUnitName = String(unitName || "").trim() || t("Unit not set");
  const decimalSeparator = languageId === "es" ? "," : ".";
  const decimalIndex = formattedValue.lastIndexOf(decimalSeparator);

  return (
    <span className={`sm-quantityValue${onUnitChange ? " sm-stockQuantity" : ""}${alignDecimals ? " sm-stockQuantity--aligned" : ""}`}>
      <span title={unavailableTitle} className={alignDecimals ? "sm-decimalNumber" : undefined} aria-live={onUnitChange ? "polite" : undefined}>
        {alignDecimals && decimalIndex >= 0 ? <><span className="sm-decimalInteger">{formattedValue.slice(0, decimalIndex)}</span><span className="sm-decimalSeparator">{decimalSeparator}</span><span className="sm-decimalFraction">{formattedValue.slice(decimalIndex + 1)}</span></> : formattedValue}
      </span>
      {onUnitChange && unitOptions.length > 1 ? (
        <select
          className="sm-stockUnitSelect"
          aria-label={t("Display unit for {0}", { 0: itemName })}
          title={t("Display only — stock records are unchanged.")}
          value={selectedLevel}
          onChange={(event) => onUnitChange(unitOptions.find((option) => option.level === event.target.value))}
        >
          {unitOptions.map((option) => <option key={option.level} value={option.level}>{option.label}</option>)}
        </select>
      ) : (
        <span className="sm-quantityUnit" title={resolvedUnitName}>
          {resolvedUnitName}
        </span>
      )}
    </span>
  );
}
